import axios from "axios";
import { store } from "state/store";

/**
 * Opérations fichiers du baromètre — hors middleware Redux (qui sérialise en
 * JSON et casserait le multipart / le binaire).
 */

const baseUrl = process.env.REACT_APP_LEMOULIN_API_URL;
const apiKey = process.env.REACT_APP_LEMOULIN_API_KEY;

function authHeaders(extra = {}) {
  const token = store.getState().session?.token || window.localStorage.getItem("token");
  return {
    Accept: "application/json",
    ...(token ? { "X-Custom-Authorization": `Bearer ${token}` } : {}),
    ...extra,
  };
}

/**
 * Upload d'un xlsx de baromètre (multipart).
 * @returns {Promise} resolve avec result { success, message, barometre }
 */
export function uploadBarometre({ file, libelle, date, template }) {
  const form = new FormData();
  form.append("fichier", file);
  form.append("libelle", libelle);
  if (date) form.append("date", date);
  if (template) form.append("template", template);

  return axios
    .post(`${baseUrl}/v2/admin/barometre/import.json?apiKey=${apiKey}`, form, {
      headers: authHeaders(), // axios pose le boundary multipart tout seul
    })
    .then((res) => res.data.result);
}

/**
 * URL de téléchargement de l'export Excel (à ouvrir dans un onglet / lien).
 */
export function exportUrl(id, template) {
  const tpl = template ? `?template=${encodeURIComponent(template)}` : "";
  return `${baseUrl}/v2/admin/barometre/${id}/export.xlsx${tpl}`;
}

function downloadBlob(path, filename) {
  return axios
    .get(`${baseUrl}${path}`, { headers: authHeaders(), responseType: "blob" })
    .then((res) => {
      const url = window.URL.createObjectURL(new Blob([res.data]));
      const a = document.createElement("a");
      a.href = url;
      a.setAttribute("download", filename);
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
    });
}

/**
 * Télécharge l'export Excel (en envoyant le JWT) et déclenche la sauvegarde.
 */
export function downloadExport(id, template, filename = "barometre.xlsx") {
  const tpl = template ? `?template=${encodeURIComponent(template)}` : "";
  return downloadBlob(`/v2/admin/barometre/${id}/export.xlsx${tpl}`, filename);
}

/**
 * Télécharge la présentation PowerPoint.
 */
export function downloadPpt(id, filename = "barometre.pptx") {
  return downloadBlob(`/v2/admin/barometre/${id}/export.pptx`, filename);
}
